import _ from "lodash";
import Box from "../components/box";
import FileLineCard from "../components/file_line_card";
import FileList from "../components/files_list_box/file_list";
import Input from "../components/input";
import h from "../core/createElement";
import Modal from "../core/modalEngine";
import report_service from "../service/report_service";
import { btn_handler, key_sequence_listener, max_height_ajustment, next_input_chain, path_name_regex, smooth_hide, switchable_element } from "../utils";
import BorderBox from "../components/borderbox";
import Btn from "../components/btn";
import popupAlerts from "../core/popupAlerts";
import GenericConfirmModal from "./generic_confirm";
import SearchBar from "../components/search_bar";
import Spinner from "../components/spinner";
import { format } from "date-fns";
import ReportTestModal from "./test_modal/report_test_modal";
import CloneModalReport from "./clone_report_modal";


function Report({ hide, onInit, id, created, updated, group_id, refresh, got_to_cloned_one, onHide, refresh_reports }) {
    let report_data, should_update_main_file_list = false, not_show_files_ids = [];

    const
        shared = { group_id },
        fields_name = ['name', 'path_name', 'file_name'],
        main_file = switchable_element(<section></section>),
        sub_reports = switchable_element(<section></section>),
        file_list_box = switchable_element(<BoxListFiles add_file={e => add_file(e)} shared={shared} hide={() => hide_file_list()} />),
        btn_add_main = <Btn title="Adicionar" name="main_add_btn" shared={shared} color="green" icon="assets/image/plus.svg" onClick={() => list_main_file()} />,
        btn_add_sub = <Btn title="Adicionar" name="sub_add_btn" shared={shared} color="green" icon="assets/image/plus.svg" onClick={() => list_sub_file()} />,
        loading = switchable_element(<Spinner />),
        additional_btns = [
            <Btn icon="assets/image/arrows-clockwise.svg" color="blue" name="refresh_btn" shared={shared} disabled={true} onClick={() => get_by_id()} />,
            <Btn title="Testar" color="dark-gray" name="test_btn" shared={shared} onClick={() => ReportTestModal.show({ report: report_data.report, id })} />,
            <section class="ml-auto flex">
                <Btn title="Clonar" shared={shared} name="clone_btn" color="orange" disabled={true} onClick={() => open_clone_modal()} />
                <Btn title="Baixar todos" shared={shared} name="download_all_btn" color="blue" disabled={true} onClick={() => download_all()} />
            </section>
        ];


    max_height_ajustment(file_list_box.current(), (h) => document.body.offsetHeight * 0.9);

    const { disable_btn, enable_btn } = btn_handler(shared);

    const
        open_clone_modal = () => CloneModalReport.show({ id, got_to_cloned_one: (d) => { hide(() => got_to_cloned_one(d)) } }),
        fetch_files = (...args) => shared.file_list_modal.fetch_files(...args),
        clean_file_list = () => shared.file_list_modal.clean_file_list(),
        has_main_file = () => !!report_data.main_report_file,
        has_sub_files = () => !!report_data.sub_report_files.length,
        could_test = () => enable_btn('test_btn', has_main_file()),
        go_to_next_input = next_input_chain(shared),
        fetch_sub_files = () => fetch_files({ type: (shared.type_of_file = 'sub_report') }, 1, not_show_files_ids),
        fetch_main_files = () => fetch_files({ type: (shared.type_of_file = 'main_report') }, 1, not_show_files_ids);


    const
        close_modal = (callback) => hide(() => {
            callback && callback()
            if (should_update_main_file_list) refresh && refresh();
        }),
        hide_file_list = () => {
            smooth_hide("closing", file_list_box);
            enable_btn(["sub_add_btn", "main_add_btn"]);
        },
        list_main_file = () => {
            clean_file_list();
            fetch_main_files();
            enable_btn("sub_add_btn");
            disable_btn("main_add_btn");
            file_list_box.show();
        },
        list_sub_file = () => {
            clean_file_list();
            fetch_sub_files();
            enable_btn("main_add_btn");
            disable_btn("sub_add_btn");
            file_list_box.show();
        },
        key_valid_path_name = (evt) => {
            go_to_next_input("file_name")(evt);

            if (!path_name_regex.test(evt.key) && evt.key != "Backspace") {
                evt.preventDefault();
                popupAlerts.warning("O Endpoint pode pussuir apenas numeros, letras e traços (_ -) ");
                shared.path_name.invalid(true);
            };
        },
        could_update = () => {
            if (!id) return;

            if (_.every(fields_name, i => shared[i].value.trim() == report_data.report[i])) {
                disable_btn(["save_btn", "refresh_btn"]);
                could_test();
            } else {
                enable_btn(["save_btn", "refresh_btn"]);
                disable_btn("test_btn");
            };
        },
        endpoint_preview = () => {
            const p = shared.path_name;
            if (p.value != "") p.subtitle(`${location.origin}/export/${p.value}`);
            else p.subtitle("");
            could_update();
        },
        file_name_preview = () => {
            const p = shared.file_name;
            if (p.value != "") p.subtitle(`${format(new Date(), "dd/MM/yyyy HH:mm")} - ${p.value}.pdf`);
            else p.subtitle("");
            could_update();
        },
        fill_subreports = (data) => {
            sub_reports.switch(
                <BorderBox title="Arquivos De Sub Relatório" buttons={btn_add_sub}>
                    {data.length ? _.map(data, e => <FileLineCard removeClick={remove_file} data={e} />) : <span class="empty">Nenhum Arquivo Vinculado</span>}
                </BorderBox>
            );
        },
        fill_mainreports = (data) => {
            main_file.switch(
                <BorderBox title="Arquivo De Relatório Principal" buttons={!data && btn_add_main}>
                    {data ? <FileLineCard data={data} removeClick={remove_file} /> : <span class="empty">Nenhum Arquivo Vinculado</span>}
                </BorderBox>
            );
        },
        is_invalid_fields = () => {
            let error = false;

            for (let i of fields_name) {
                const input = shared[i];

                if (input.value == "" || input.value.length < 4 || input.value.length > 64) {
                    input.invalid(true);
                    error = true;
                };
            };
            if (error) popupAlerts.warning("Preencha corretamente os campos!");

            return error;
        },
        handle_invalid_fields_by_request = (err) => {
            if (err.response && err.response?.data) {
                const data = err.response.data;

                if (data.messages) _.forEach(data.messages, msg => { shared[msg.field].invalid(true) });
            };
        },
        create_report = async () => {
            try {
                if (is_invalid_fields()) return;

                loading.show();

                const body = _.chain(fields_name).map(i => [i, shared[i].value.trim()]).fromPairs().value();
                body.group_id = +group_id;

                const { data } = await report_service.create(body);

                loading.hide();

                hide(() => created && created(data.data));

                popupAlerts.success("Relatório criado com sucesso!");
            } catch (e) {
                loading.hide();
                handle_invalid_fields_by_request(e);
            };
        },
        update_report = async () => {
            try {
                if (is_invalid_fields()) return;

                loading.show();

                const body = _.chain(fields_name).map(i => [i, shared[i].value.trim()]).fromPairs().value();

                const { data } = await report_service.update(body, id);

                popupAlerts.success("Relatório editado com sucesso!");

                await get_by_id();

                updated && await updated();
            } catch (e) {
                loading.hide();
                handle_invalid_fields_by_request(e);
            };
        },
        save_handler = () => {
            if (id) GenericConfirmModal.show({ title: "Atualizar relatório", text: "Deseja realmente alterar este relatório?", confirm: update_report });
            else create_report();
        },
        get_by_id = async () => {
            try {
                loading.show();

                const { name, path_name, file_name } = shared;

                const { data } = await report_service.get_by_id(id);

                report_data = data;
                name.value = data.report.name;
                path_name.value = data.report.path_name;
                file_name.value = data.report.file_name;

                endpoint_preview();
                file_name_preview();

                shared.not_show_files_ids = not_show_files_ids = [];

                if (has_main_file()) not_show_files_ids.push(data.main_report_file.id);
                if (has_sub_files()) _.forEach(data.sub_report_files, e => { not_show_files_ids.push(e.id) });

                enable_btn("download_all_btn", !!(has_main_file() || has_sub_files()));
                enable_btn("clone_btn", (data.can_be_cloned && has_main_file()));
                could_test();

                fill_mainreports(data.main_report_file);
                fill_subreports(data.sub_report_files);

                loading.hide();
            } catch (e) {
                loading.hide();
                hide();
            };
        },
        remove_file = (f) => {
            if (file_list_box.is_visible()) hide_file_list();

            GenericConfirmModal.show({
                title: "Desvincular arquivo",
                text: `Deseja realmente desvincular ${f.name}?`,
                confirm: async () => {
                    try {
                        loading.show();

                        const { data } = await report_service.remove_file_from_report(f.id, report_data.report.id);

                        popupAlerts.success("Arquivo desvinculado com sucesso!");

                        should_update_main_file_list = true;

                        await get_by_id(); //essa função desativará o spinner
                    } catch (e) {
                        loading.hide();
                    };
                }
            });
        },
        add_file = (f) => {
            GenericConfirmModal.show({
                title: "Vincular arquivo",
                text: `Deseja vincular ${f.name} a este relatório?`,
                confirm: async () => {
                    try {
                        loading.show();
                        // main_report | sub_report
                        const { data } = await report_service[f.type](f.id, report_data.report.id);

                        popupAlerts.success("Arquivo vinculado com sucesso!");

                        should_update_main_file_list = true;

                        get_by_id();
                    } catch (e) {
                        loading.hide();
                    };
                    hide_file_list();
                }
            });
        },
        download_all = async () => {
            const progress_bar = popupAlerts.progress('A fazer o download...');
            try {
                const progress_callback = (evt) => {
                    progress_bar.progress((evt.loaded / evt.total) * 100)
                };

                const { data } = await report_service.download_files(progress_callback, id);

                progress_bar.dismiss();

                const url = window.URL.createObjectURL(new Blob([data]));

                const a = h('a', { href: url, style: "display: none;", download: report_data.report.name + ".zip" });

                document.body.appendChild(a);

                a.click();
                a.remove();
            } catch (e) {
                progress_bar.dismiss();
            }
        },
        delete_report = async () => {
            if (GenericConfirmModal.is_opened) return;
            CloneModalReport.hide();
            ReportTestModal.hide();

            GenericConfirmModal.show({
                title: "Excluir relatório: " + id,
                text: "Esta é uma ação permanente, os arquivos vinculados não serão afetados!",
                confirm: async () => {
                    try {
                        loading.show();

                        const { data } = await report_service.delete(id);

                        refresh_reports && await refresh_reports();

                        popupAlerts.success("Relatório excluido com sucesso!");

                        loading.hide();

                        hide();
                    } catch (e) {
                        loading.hide();
                    };
                    hide_file_list();
                }
            })
        };

    let key_sec_remove;

    onInit(async () => {
        if (id) {
            await get_by_id();

            key_sec_remove = key_sequence_listener(['d', 'e', 'l', 't'], delete_report)
        }
        else if (!group_id) {
            popupAlerts.danger("Crie uma aplicação(grupo) para prosseguir!");
            hide();
            return;
        } else shared.save_btn.enable();
    });

    onHide(() => {
        if (key_sec_remove) key_sec_remove();
    })

    return (
        <section class="flex justify-center container-modal-report">
            {file_list_box.marker()}

            {max_height_ajustment(
                <Box title={id ? `Relatório: ${id}` : "Novo Relatório"} containerClass="form-box" buttons={<Btn icon="assets/image/x_white.svg" onClick={() => close_modal()} color="red" />}>
                    <section class="full-size flex-column form-report-content form-modal-content">
                        <section class="flex-column flex-1">
                            <Input shared={shared} title="Nome" name="name" placeholder="Nome do relatório deve possuir entre 4 e 64 caracteres" onKeyup={could_update} onKeydown={go_to_next_input('path_name')} />
                            <Input shared={shared} title="Endpoint" name="path_name" placeholder="Endpoint deve possuir entre 4 e 64 caracteres" onKeyup={endpoint_preview} onKeydown={key_valid_path_name} />
                            <Input shared={shared} title="Nome do arquivo de saida" name="file_name" onKeyup={file_name_preview} placeholder="Nome do arquivo deve possuir entre 4 e 64 caracteres" />

                            <section class="flex save-btn-container">
                                <Btn title="Salvar" color="green" name="save_btn" shared={shared} disabled={true} onClick={save_handler} />

                                {id ? additional_btns : ""}
                            </section>
                        </section>

                        {main_file.current()}
                        {sub_reports.current()}
                    </section>
                    {loading.marker()}
                </Box>
                ,
                (h) => document.body.offsetHeight * 0.9 - 60
            )}
        </section>
    );
};

function BoxListFiles({ shared, hide, add_file }) {
    const header_btns = [
        <SearchBar onSearch={(v) => search_file_by_name(v)} placeholder="Pesquisar por nome" />,
        <Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />
    ];

    const search_file_by_name = (v) => shared.file_list_modal.fetch_files({ name: v, type: shared.type_of_file }, 1, shared.not_show_files_ids);

    return (
        <Box title="Arquivos" containerClass="file-box min-w-450" buttons={header_btns}>
            <FileList name="file_list_modal" cardClick={add_file} shared={shared} hide-card-btns={true} />
        </Box>
    );
};

const ReportModal = new Modal(Report);

export default ReportModal;